<template>
  <a-modal
    title="沟通结果"
    v-model="visible"
    :destroyOnClose="true"
    @ok="visible = false"
  >
    <a-row type="flex" align="top" :gutter="10">
      <a-col span="6"
        ><p><b>沟通结果：</b></p></a-col
      >
      <a-col span="18"
        ><span style="color:rgb(66, 185, 131)">{{
          record.status == "SUCCESS" ? "已获取简历" : "未获取简历"
        }}</span></a-col
      >
    </a-row>
    <a-row type="flex" align="top" :gutter="10">
      <a-col span="6"
        ><p><b>备注内容：</b></p></a-col
      >
      <a-col span="18">{{ record.remark }}</a-col>
    </a-row>
    <a-row type="flex" align="top" :gutter="10">
      <a-col span="6"
        ><p><b>操作人：</b></p></a-col
      >
      <a-col span="18">{{ record.updated_by_name }}</a-col>
    </a-row>
    <a-row type="flex" align="top" :gutter="10">
      <a-col span="6"
        ><p><b>操作时间：</b></p></a-col
      >
      <a-col span="18">{{ record.updated_at }}</a-col>
    </a-row>
  </a-modal>
</template>
<script>
export default {
  name: "MarkDetailModal",
  data() {
    return {
      record: {},
      visible: false
    };
  },
  methods: {
    show(record) {
      this.visible = true;
      this.record = record;
    },
    close() {
      this.visible = false;
    }
  }
};
</script>

<style scoped lang="scss"></style>
